import Heading from 'components/global/Heading';
import Bilboard from 'assets/images/bilboard.png';
import { Swiper , SwiperSlide } from 'swiper/react';
import './slider.css';

import { Autoplay , Pagination } from 'swiper';
import { useNavigate } from 'react-router-dom';

const Slider = ({ heading }) => {
    const navigate = useNavigate();

    const seeAllScreenHandler = () => {
        navigate('/user/seller-screens/049')
    }

    return (
        <div className='w-full mt-8'>
            <Heading 
            title={heading}
            />
            <div className='w-full pt-12 overflow-x-hidden'>
                <Swiper
                    slidesPerView={2}
                    spaceBetween={25}
                    pagination={{
                        clickable: true,
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    speed={500}
                    loop={true}
                    modules={[Pagination , Autoplay]}
                    className="user-dashboard-slider"
                    breakpoints={{
                        900 : {
                            slidesPerView : 2
                        } ,
                        768 : {
                            slidesPerView : 1
                        } ,
                        550 : {
                            slidesPerView : 2
                        } ,
                        200 : {
                            slidesPerView : 1
                        }

                    }}
                >
                    {
                        [...Array(6).keys()].map((item,i) => (
                            <SwiperSlide 
                            className='w-full bg-pure rounded-lg p-2 light-shadow' 
                            key={i}
                            >
                                <div>
                                    <img src={Bilboard} alt="Case Study" className='w-full h-full' />
                                </div>
                                <div className='text-dark flex flex-col gap-1 mt-4'>
                                    <p>Starting Price: 3000INR</p>
                                    <p>Total Impression: 600k/m</p> 
                                    <p>Media Type: Static Image/Video</p>
                                    <p>Ad Medium: Billboards & Digital Screen</p>
                                    <p>Minimum Play: 1500</p>
                                    <p>Location: Banglore ,India</p>
                                </div>
                                <div className='pt-6 pb-4'>
                                    <button 
                                    className="btn-primary py-2"
                                    onClick={() => {
                                        seeAllScreenHandler()
                                    }}
                                    >
                                        See All Screens
                                    </button>
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
            </div>
            
        </div>
    )
}

export default Slider